import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumStockTakeStatus implements BaseEnumType {
  private static allValues: EnumStockTakeStatus[] = []; // make sure this is top-most
  
  public static none = new EnumStockTakeStatus(0, "None", "enum_stock_take_status_none");
  public static open = new EnumStockTakeStatus(1, "Open", "enum_stock_take_status_open");
  public static inProgress = new EnumStockTakeStatus(2, "InProgress", "enum_stock_take_status_in_progress");
  public static cancelled = new EnumStockTakeStatus(3, "Cancelled", "enum_stock_take_status_cancelled");
  public static complete = new EnumStockTakeStatus(4, "Complete", "enum_stock_take_status_complete");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumStockTakeStatus.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumStockTakeStatus.none; }
  public isOpen() { return this === EnumStockTakeStatus.open; }
  public isInProgress() { return this === EnumStockTakeStatus.inProgress; }
  public isCancelled() { return this === EnumStockTakeStatus.cancelled; }
  public isComplete() { return this === EnumStockTakeStatus.complete; }

  public static getValues(): readonly EnumStockTakeStatus[] {
    return EnumStockTakeStatus.allValues;
  }

  public static getValuesExcept0(): readonly EnumStockTakeStatus[] {
    return EnumStockTakeStatus.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumStockTakeStatus {
    const found = EnumStockTakeStatus.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumStockTakeStatus - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumStockTakeStatus): EnumStockTakeStatus {
    const found = name ? EnumStockTakeStatus.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumStockTakeStatus - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumStockTakeStatus>): boolean {
    return this.key === other?.key;
  }
}